'use client';

import { ComponentProps, Dispatch, SetStateAction, useState } from 'react';
import MetaNavigation from './meta-navigation';
import Flyout, { FooterNavigationItem } from './flyout';
import ScrollToTopButton from './scroll-to-top-button';
import FooterGrid from './footer-grid';
import { EventClickArea } from '@tuic/tracking';
import { FooterCookieSettingsOpener } from './FooterCookieSettingsOpener';
import { Locale } from '@tuic/i18n';
import { I18NFromComponent } from '../../../utils';
import AppStoreRating from './app-store-rating';
export type FooterProps = {
  meta: ComponentProps<typeof MetaNavigation>;
  items: FooterNavigationItem[];
  locale?: Locale;
  i18n?: I18NFromComponent<typeof AppStoreRating>;
};
const createFlyoutToggle = (activeFlyout: undefined | number, setActiveFlyout: Dispatch<SetStateAction<number | undefined>>, idx: number) => {
  if (activeFlyout === idx) {
    return () => {
      setActiveFlyout(undefined);
    };
  }
  return () => setActiveFlyout(idx);
};
const Footer = ({
  meta,
  items,
  locale,
  i18n
}: FooterProps) => {
  const [activeFlyout, setActiveFlyout] = useState<number | undefined>(undefined);
  if (!meta || !items) return null;
  return <footer data-track-click-area={EventClickArea.Footer} className="bg-primary-ocean-100 lg:py-[3.75rem] [&_a]:no-underline" data-sentry-component="Footer" data-sentry-source-file="Footer.tsx">
      <nav className="relative mx-auto my-0 flex max-w-[1200px] flex-col px-0 leading-[1.4] text-secondary-marine-100 lg:px-[3.125rem] xl:max-w-[1300px] xl:px-[4.375rem]">
        <FooterGrid data-sentry-element="FooterGrid" data-sentry-source-file="Footer.tsx">
          <FooterGrid.MetaSegment className={'block lg:hidden'} data-sentry-element="FooterGrid.MetaSegment" data-sentry-source-file="Footer.tsx">
            <MetaNavigation locale={locale} {...meta} i18n={i18n} data-sentry-element="MetaNavigation" data-sentry-source-file="Footer.tsx" />
          </FooterGrid.MetaSegment>

          {items.map((item, idx) => <FooterGrid.LinkCollectionSegment key={item.title}>
              <Flyout isActive={activeFlyout === idx} handleToggle={createFlyoutToggle(activeFlyout, setActiveFlyout, idx)} item={item} />
            </FooterGrid.LinkCollectionSegment>)}

          <FooterGrid.MetaSegment className={'hidden lg:block'} data-sentry-element="FooterGrid.MetaSegment" data-sentry-source-file="Footer.tsx">
            <MetaNavigation locale={locale} {...meta} data-sentry-element="MetaNavigation" data-sentry-source-file="Footer.tsx" />
          </FooterGrid.MetaSegment>

          <FooterGrid.ScrollToTopSegment data-sentry-element="FooterGrid.ScrollToTopSegment" data-sentry-source-file="Footer.tsx">
            <ScrollToTopButton data-sentry-element="ScrollToTopButton" data-sentry-source-file="Footer.tsx" />
          </FooterGrid.ScrollToTopSegment>
        </FooterGrid>
      </nav>
      <FooterCookieSettingsOpener data-sentry-element="FooterCookieSettingsOpener" data-sentry-source-file="Footer.tsx" />
    </footer>;
};
export { Footer };